module.exports = __webpack_public_path__ + "static/photo28@2x-9fa69df6d7410e39fd1fbab62068156b.png";